import { QuotationTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1550. 見積タスクファイル登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/quotation_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  name: string;
  file?: string;
  url?: string;
};

const createQuotationTaskDocument = (props: Props): Promise<QuotationTaskDocument> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/quotation_task_documents`,
    props
  );
};

export const useCreateQuotationTaskDocument = () => {
  return useMutation({
    mutationFn: createQuotationTaskDocument
  });
};
